// Copyright (c) 2017 Deere & Company

import UpdateLayoutModal from './update-layout-modal';
import {connect} from 'react-redux';
import {sharedActionCreators} from '../../../action-creators';

const getStateToBindToContainerProps = state => ({
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isOpen: state.reportVariant.isUpdateLayoutModalOpen,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    ...ownProps
});

export default connect(getStateToBindToContainerProps, sharedActionCreators, mapBoundActionCreatorsToActionsProp)(UpdateLayoutModal);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/update-layout-modal/index.js